// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "video[data-v-7a3c83da] {\n  display: block;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  background: #000 center/100% no-repeat;\n  -o-object-fit: cover;\n     object-fit: cover;\n  max-width: 750px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
